export default {
  name: '',
  typé: '',
  data: [],
};
